import { IndentationOptions } from '@ryusei/code';


/**
 * The default options for the Tab component.
 *
 * @since 0.1.0
 */
export const DEFAULT_OPTIONS: IndentationOptions = {
  help      : true,
  deepIndent: true,
};
